<template>
<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 90 90">
  <g>
    <path class="cls-4" d="m76.89,17.09v8.03H13.11v-8.03c0-2.18,1.79-3.98,3.98-3.98h55.81c2.19,0,3.98,1.79,3.98,3.98Z"/>
    <path class="cls-4" d="m78.03,26.26H11.97v-9.17c0-2.82,2.3-5.12,5.12-5.12h55.81c2.82,0,5.12,2.29,5.12,5.12v9.17Zm-63.78-2.28h61.5v-6.9c0-1.57-1.28-2.84-2.85-2.84H17.1c-1.57,0-2.85,1.27-2.85,2.84v6.9Z"/>
  </g>
  <path class="cls-5" d="m72.9,78.03H17.1c-2.82,0-5.12-2.3-5.12-5.12V23.99h66.05v48.92c0,2.82-2.3,5.12-5.12,5.12ZM14.25,26.26v46.64c0,1.57,1.28,2.85,2.85,2.85h55.81c1.57,0,2.85-1.28,2.85-2.85V26.26H14.25Z"/>
  <rect class="cls-5" x="54.49" y="25.12" width="2.28" height="51.76"/>
  <rect class="cls-5" x="33.23" y="25.12" width="2.28" height="51.76"/>
  <g>
    <line class="cls-2" x1="13.11" y1="42.38" x2="76.89" y2="42.38"/>
    <rect class="cls-5" x="13.11" y="41.24" width="63.78" height="2.28"/>
  </g>
  <g>
    <line class="cls-2" x1="13.11" y1="59.63" x2="76.89" y2="59.63"/>
    <rect class="cls-5" x="13.11" y="58.5" width="63.78" height="2.28"/>
  </g>
  <g>
    <circle class="cls-1" cx="45" cy="51.01" r="16.31"/>
    <path class="cls-2" d="m45,68.46c-9.62,0-17.45-7.83-17.45-17.45s7.83-17.45,17.45-17.45,17.45,7.83,17.45,17.45-7.83,17.45-17.45,17.45Zm0-32.63c-8.37,0-15.17,6.81-15.17,15.17s6.81,15.17,15.17,15.17,15.17-6.81,15.17-15.17-6.81-15.17-15.17-15.17Z"/>
  </g>
  <path class="cls-3" d="m46.41,40.69l-.02,2.43c.96.09,1.86.28,2.7.57.84.28,1.57.64,2.17,1.08l-1.15,3.15c-.65-.46-1.41-.83-2.29-1.1-.88-.27-1.78-.41-2.69-.42s-1.55.11-1.92.36c-.37.25-.56.56-.56.92,0,.31.12.57.37.79.25.21.71.4,1.37.55l2.49.55c2.71.62,4.05,2.1,4.03,4.42,0,1.24-.43,2.28-1.27,3.14-.84.86-1.96,1.41-3.36,1.67l-.02,2.54-3.07-.02.02-2.47c-.77-.09-1.5-.28-2.19-.57-.7-.29-1.27-.64-1.73-1.05l1.1-2.95c.53.42,1.15.74,1.87.97.72.23,1.49.35,2.32.36.77,0,1.36-.13,1.79-.41.43-.28.64-.64.65-1.08,0-.29-.12-.54-.37-.74-.25-.2-.69-.38-1.32-.53l-2.49-.57c-2.75-.62-4.12-2.07-4.1-4.34,0-1.25.44-2.29,1.28-3.13s1.95-1.37,3.3-1.61l.02-2.54,3.07.02Z"/>
  <g>
    <circle class="cls-1" cx="58.93" cy="62.72" r="6.71"/>
    <path class="cls-2" d="m58.93,69.9c-3.96,0-7.17-3.22-7.17-7.18s3.22-7.18,7.17-7.18,7.18,3.22,7.18,7.18-3.22,7.18-7.18,7.18Zm0-13.41c-3.44,0-6.24,2.8-6.24,6.24s2.8,6.24,6.24,6.24,6.24-2.8,6.24-6.24-2.8-6.24-6.24-6.24Z"/>
  </g>
  <path class="cls-2" d="m58.93,58.25c-.06,0-.12-.05-.12-.12v-1.02c0-.06.05-.12.12-.12s.12.05.12.12v1.02c0,.06-.05.12-.12.12Z"/>
  <g>
    <line class="cls-1" x1="54.96" y1="58.75" x2="55.34" y2="59.14"/>
    <path class="cls-2" d="m55.34,59.26s-.06-.01-.08-.03l-.39-.39s-.05-.12,0-.17.12-.05.17,0l.39.39s.05.12,0,.17c-.02.02-.05.03-.08.03Z"/>
  </g>
  <g>
    <line class="cls-1" x1="53.31" y1="62.72" x2="54.33" y2="62.72"/>
    <path class="cls-2" d="m54.33,62.84h-1.02c-.06,0-.12-.05-.12-.12s.05-.12.12-.12h1.02c.06,0,.12.05.12.12s-.05.12-.12.12Z"/>
  </g>
  <g>
    <line class="cls-1" x1="55.12" y1="66.52" x2="55.51" y2="66.14"/>
    <path class="cls-2" d="m55.12,66.64s-.06-.01-.08-.03c-.05-.05-.05-.12,0-.17l.39-.39s.12-.05.17,0,.05.12,0,.17l-.39.39s-.05.03-.08.03Z"/>
  </g>
  <g>
    <line class="cls-1" x1="58.93" y1="68.34" x2="58.93" y2="67.31"/>
    <path class="cls-2" d="m58.93,68.45c-.06,0-.12-.05-.12-.12v-1.02c0-.06.05-.12.12-.12s.12.05.12.12v1.02c0,.06-.05.12-.12.12Z"/>
  </g>
  <g>
    <line class="cls-1" x1="62.73" y1="66.52" x2="62.34" y2="66.14"/>
    <path class="cls-2" d="m62.73,66.64s-.06-.01-.08-.03l-.39-.39s-.05-.12,0-.17.12-.05.17,0l.39.39s.05.12,0,.17c-.02.02-.05.03-.08.03Z"/>
  </g>
  <g>
    <line class="cls-1" x1="64.54" y1="62.72" x2="63.52" y2="62.72"/>
    <path class="cls-2" d="m64.54,62.84h-1.02c-.06,0-.12-.05-.12-.12s.05-.12.12-.12h1.02c.06,0,.12.05.12.12s-.05.12-.12.12Z"/>
  </g>
  <g>
    <line class="cls-1" x1="62.73" y1="58.75" x2="62.34" y2="59.14"/>
    <path class="cls-2" d="m62.34,59.26s-.06-.01-.08-.03c-.05-.05-.05-.12,0-.17l.39-.39s.12-.05.17,0,.05.12,0,.17l-.39.39s-.05.03-.08.03Z"/>
  </g>
  <g>
    <line class="cls-1" x1="53.31" y1="62.72" x2="54.33" y2="62.72"/>
    <path class="cls-2" d="m54.33,62.84h-1.02c-.06,0-.12-.05-.12-.12s.05-.12.12-.12h1.02c.06,0,.12.05.12.12s-.05.12-.12.12Z"/>
  </g>
  <g>
    <line class="cls-1" x1="58.93" y1="68.34" x2="58.93" y2="67.31"/>
    <path class="cls-2" d="m58.93,68.45c-.06,0-.12-.05-.12-.12v-1.02c0-.06.05-.12.12-.12s.12.05.12.12v1.02c0,.06-.05.12-.12.12Z"/>
  </g>
  <g>
    <line class="cls-1" x1="64.54" y1="62.72" x2="63.52" y2="62.72"/>
    <path class="cls-2" d="m64.54,62.84h-1.02c-.06,0-.12-.05-.12-.12s.05-.12.12-.12h1.02c.06,0,.12.05.12.12s-.05.12-.12.12Z"/>
  </g>
  <g>
    <polyline class="cls-1" points="57.53 59.18 58.93 62.72 62.53 64.39"/>
    <path class="cls-5" d="m62.53,64.74s-.1-.01-.15-.03l-3.74-1.73-1.45-3.68c-.07-.18.02-.38.2-.46.18-.07.38.02.46.2l1.35,3.42,3.48,1.61c.18.08.25.29.17.47-.06.13-.19.2-.32.2Z"/>
  </g>
</svg>
</template>

<script>
export default {
    name: "TimePriceTableIcon",
}
</script>

<style scoped>
    .cls-1 {
      fill: #fff;
    }
    .cls-2 {
      fill: #0f5b71;
    }
    .cls-3 {
      fill: #c1e4d6;
    }
    .cls-4 {
      fill: #115c72;
    }
    .cls-5 {
      fill: #59c5c7;
    }
</style>